export var json = {

  locale: "en",
   
    pages: [
        {
            "name" : "page 2",
            
            elements: [
              {
                "type": "dropdown",
                "name": "country",
                "title": {
                  "en" : "In which country do you currently reside?",
                  "es" : "¿En qué país reside actualmente?",
                  "gr" : "Σε ποια χώρα διαμένετε αυτή τη στιγμή;",
                  "du" : "In welk land woont u op dit moment?"
                }
                ,

                "colCount": 0,
                "hasNone": true,
                "choices": [
                  "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Congo, The Democratic Republic of the", "Cook Islands", "Costa Rica", "Cote D'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and Mcdonald Islands", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran, Islamic Republic Of", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Republic of Korea", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Macedonia, The Former Yugoslav Republic of", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova, Republic of", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestinian Territory, Occupied", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "RWANDA", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan, Province of China", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Viet Nam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe",
                ]
            },
        
        
            {
              "type": "radiogroup",
              "name": "age",
              "title":  {
                "en" : "How old are you?",
                "es" : "¿Cuantos años tiene?",
                "gr" : "Πόσο χρονών είστε?",
                "du" : "Hoe oud bent u?"
              },
              "choices": [
               {
                "value": "item1",
                "text": {
                  "en" : "Under 25",
                  "es" : "Menos de 25",
                  "gr" : "Κάτω από 25  ",
                  "du" : "Jonger dan 25"
               }
               },
               {
                "value": "item2",
                "text": "25-34"
               },
               {
                "value": "item3",
                "text": "35-44"
               },
               {
                "value": "item4",
                "text": "45-54"
               },
               {
                "value": "item5",
                "text": {
                  "en" : "Over 55",
                  "es" : "Más de 55",
                  "gr" : "Πάνω από 55",
                  "du" : "Ouder dan 55"
               }
               }
              ]
             },
        
        
            
        
        
            {
              "type" : "text",
              "name" : "year",
              "title" : {
                "en" : "In which year did you complete the formal qualification that qualified you to teach? An approximate year is sufficient.",
                "es" : "¿En qué año finalizó la formación que le habilita para su función docente? Un año aproximado es suficiente",
                "gr" : "Ποιά χρονιά αποκτήσατε τα επίσημα προσόντα/ολοκληρώσατε τις σπουδές που σας επιτρέπουν να διδάξετε;  Η χρονιά κατά προσέγγιση επαρκεί",
                "du" : "In welk jaar voltooide u de formele opleiding die u kwalificeerde om les te geven? Een geschat jaar is voldoende"
              },
              "width" : "40em",
              
            },
        
            {
              "type": "radiogroup",
              "name": "highed",
              "title": {
                "en" : "What is the highest level of formal education you have completed to date?",
                "es" : "¿Cuál es su titulación académica mas alta obtenida hasta la fecha?",
                "gr" : "Ποιο είναι το υψηλότερο επίπεδο τυπικής εκπαίδευσης που έχετε ολοκληρώσει έως σήμερα;",
                "du" : "Wat is het hoogste niveau van formele opleiding dat u tot nu toe hebt voltooid?"
              },
              "choices": [
                {
                  "value": "item1",
                  "text": {
                    "en" : "Bachelor’s or equivalent ",
                    "es" : "Grado-Licenciatura o equivalente",
                    "gr" : "Ανώτερη εκπαίδευση ή αντίστοιχο",
                    "du" : "Bachelor diploma"
                 }},
                 {
                  "value": "item2",
                  "text": {
                    "en" : "Master’s or equivalent",
                    "es" : "Máster o equivalente",
                    "gr" : "Μεταπτυχιακός Τίτλος Σπουδών ή αντίστοιχο",
                    "du" : "Master diploma"
                 }},
                 {
                  "value": "item3",
                  "text": {
                    "en" : "Doctoral or equivalent",
                    "es" : "Doctorado o equivalente",
                    "gr" : "Διδακτορικό Δίπλωμα ή αντίστοιχο",
                    "du" : "Doctoraat"
                 }
                }
              ]
             },
        
        
             
             {
              "type": "checkbox",
              "name": "subcat",
              "title": {
                "en" : "Which of the following subject categories do you teach during the current school year to any students in your school?",
                "es" : "¿Cuál de las siguientes categorías de materias/asignaturas enseña durante este curso escolar?",
                "gr" : "Ποια από τις παρακάτω κατηγορίες θεμάτων διδάσκετε κατά τη διάρκεια της τρέχουσας σχολικής χρονιάς;",
                "du" : "In welke van de volgende vakcategorieën geeft u dit lopende schooljaar les?"
              },
              "choices": [
                {
                  "value": "item1",
                  "text": {
                    "en" : "Reading, writing and literature Includes reading and writing (and literature) in the mother tongue, in the language of instruction, or in the tongue of the country (region) as a second language (for non-natives); language studies, public speaking, literature.",
                    "es" : "Lectura, escritura y literatura: Incluye lectura y escritura (y literatura) en la lengua materna, en la lengua de instrucción, o en la lengua del país (región) como segunda lengua (para no nativos); estudios de idiomas, oratoria, literatura",
                    "gr" : "Ανάγνωση, γραφή και λογοτεχνία Περιλαμβάνει την ανάγνωση και την γραφή (και τη λογοτεχνία) στη μητρική γλώσσα, στη γλώσσα διδασκαλίας ή στη γλώσσα της χώρας ως δεύτερη γλώσσα (για μη γηγενείς)· γλωσσικές σπουδές, δημόσια ομιλία, λογοτεχνία ",
                    "du" : "Lezen, schrijven en literatuur. Omvat lezen en schrijven (en literatuur) in de moedertaal, in de instructietaal, of in de taal van het land (regio) als tweede taal (voor anderstaligen); taalstudies, spreken in het openbaar, literatuur "
                  }},
                  {
                  "value": "item2",
                  "text": {
                    "en" : "Mathematics Includes mathematics, mathematics with statistics, geometry, algebra, etc.",
                    "es" : "Matemáticas: Incluye matemáticas, matemáticas con estadística, geometría, álgebra, etc.",
                    "gr" : "Μαθηματικά Περιλαμβάνει μαθηματικά, μαθηματικά με στατιστική, γεωμετρία, άλγεβρα κ.λπ. ",
                    "du" : "Wiskunde. Omvat wiskunde, wiskunde met statistiek, meetkunde, algebra, enz."
                  }},
                  {
                  "value": "item3",
                  "text": {
                    "en" : "Science Includes science, physics, physical science, chemistry, biology, human biology, environmental science, agriculture/horticulture/forestry.",
                    "es" : "Ciencia: Incluidas ciencias, física, educación física, química, biología, biología humana, ciencias ambientales, agricultura/horticultura/Ciencias forestales.",
                    "gr" : "Θετικές Επιστήμες Περιλαμβάνει φυσική, χημεία, βιολογία, ανθρώπινη βιολογία, περιβαλλοντική εκπαίδευση, γεωργία/κηπευτική/δασοκομία",
                    "du" : "Wetenschap. Omvat wetenschap, natuurkunde, natuurkunde, scheikunde, biologie, menselijke biologie, milieukunde, land-/tuinbouw/bosbouw"
                  }},
                  {
                  "value": "item4",
                  "text": {
                    "en" : "Social studies Includes social studies, community studies, contemporary studies, economics, environmental studies, geography, history, humanities, legal studies, studies of the own country, social sciences, ethical thinking, philosophy",
                    "es" : "Ciencias Sociales: Incluidos estudios sociales, estudios de la comunidad, estudios contemporáneos, economía, estudios ambientales, geografía, historia, humanidades, derecho, estudios del propio país, ciencias sociales, ética, filosofía.",
                    "gr" : "Κοινωνικές επιστήμες Περιλαμβάνει σύγχρονες σπουδές, οικονομικά, περιβαλλοντικές μελέτες, γεωγραφία, ιστορία, ανθρωπιστικές επιστήμες, νομικές σπουδές, εθνικές μελέτες, κοινωνικές επιστήμες, ηθική σκέψη, φιλοσοφία ",
                    "du" : "Sociale wetenschappen. Omvat sociale studies, gemeenschapsstudies, hedendaagse studies, economie, milieustudies, aardrijkskunde, geschiedenis, geesteswetenschappen, juridische studies, studies van het eigen land, sociale wetenschappen, ethisch denken, filosofie"
                  }},
                  {
                  "value": "item5",
                  "text": {
                    "en" : "Languages Includes languages different from the language of instruction",
                    "es" : "Idiomas: Incluidas idiomas distintas a la materna o al idioma de instrucción",
                    "gr" : "Γλώσσες Περιλαμβάνει γλώσσες διαφορετικές από την γλώσσα διδασκαλίας",
                    "du" : "Talen. Omvat andere talen dan de instructietaal"
                  }},
                  {
                  "value": "item6",
                  "text": {
                    "en" : "Ancient Greek and/or Latin ",
                    "es" : "Griego antiguo y/o latín",
                    "gr" : "Αρχαία Ελληνικά ή/και Λατινικά",
                    "du" : "Oudgrieks en/of Latijn"
                  }},
                  {
                  "value": "item7",
                  "text": {
                    "en" : "Technology Includes orientation in technology, including information technology, computer studies, construction/surveying, electronics, graphics and design, keyboard skills, word processing, workshop technology/design technology",
                    "es" : "Tecnología: Incluidos orientación en tecnología, incluida las tecnologías de la información, informática, construcción/topografía, electrónica, diseño gráfico, habilidades con el teclado, procesamiento de textos, tecnología de taller/tecnología de diseño ",
                    "gr" : "Τεχνολογία Περιλαμβάνει προσανατολισμό στην τεχνολογία, συμπεριλαμβανομένης της τεχνολογίας πληροφοριών, σπουδών υπολογιστών, κατασκευής/τοπογραφίας, ηλεκτρονικών ειδών, γραφικών και σχεδίου, δεξιότητες πληκτρολογίου, επεξεργασίας κειμένου, τεχνολογίας εργαστηρίων/τεχνολογίας σχεδίασης ",
                    "du" : "Technologie. Omvat oriëntatie in technologie, waaronder informatietechnologie, computerstudies, constructie/landmeten, elektronica, grafisch ontwerp, toetsenbordvaardigheden, tekstverwerking, werkplaatstechnologie/ontwerptechnologie"
                  }},
                  {
                  "value": "item8",
                  "text": {
                    "en" : "Arts Includes arts, music, visual arts, practical art, drama, performance music, photography, drawing, creative handicraft, creative needlework  ",
                    "es" : "Letras: Incluidas artes, música, artes visuales, arte práctico, teatro, interpretación musical, fotografía, dibujo, artesanía creativa, costura creativa.",
                    "gr" : "Τέχνες Περιλαμβάνει τέχνες, μουσική, εικαστικές τέχνες, πρακτική τέχνη, δράμα, μουσική παράστασης, φωτογραφία, σχέδιο, δημιουργική χειροτεχνία, δημιουργικά κεντήματα",
                    "du" : "Kunst. Omvat kunst, muziek, beeldende kunst, praktische kunst, drama, performance, muziek, fotografie, tekenen, creatief handwerk, creatief handwerk"
                  }},
                  {
                  "value": "item9",
                  "text": {
                    "en" : "Physical education Includes physical education, gymnastics, dance, health  ",
                    "es" : "Educación: FísicaIncluidas educación física, gimnasia, danza, salud.",
                    "gr" : "Φυσική αγωγή Περιλαμβάνει φυσική αγωγή, γυμναστική, χορό, αγωγή υγείας",
                    "du" : "Lichamelijke opvoeding. Omvat lichamelijke opvoeding, gymnastiek, dans, gezondheid"
                  }},
                  {
                  "value": "item10",
                  "text": {
                    "en" : "Religion and/or ethics Includes religion, history of religions, religion culture, ethics  ",
                    "es" : "Religión y/o ética: Incluidas religión, historia de las religiones, cultura de la religión, ética.",
                    "gr" : "Θρησκεία ή/και ηθική Περιλαμβάνει τη θρησκεία, την ιστορία των θρησκειών, τον πολιτισμό της θρησκείας, την ηθική",
                    "du" : "Religie en/of ethiek. Omvat religie, geschiedenis van religies, religieuze cultuur, ethiek "
                  }},
                  {
                  "value": "item11",
                  "text": {
                    "en" : "Practical and vocational skills Includes vocational skills (preparation for a specific occupation), technics, domestic science, accountancy, business studies, career education, clothing and textiles, driving, home economics, polytechnic courses, secretarial studies, tourism and hospitality, handicraft ",
                    "es" : "Habilidades prácticas y profesionales: Incluidas habilidades vocacionales (preparación para una ocupación específica), técnicas, actividades domésticas, contabilidad, estudios comerciales, educación profesional, vestuario y textiles, conducción, economía doméstica, cursos politécnicos, estudios de secretariado, turismo y hotelería, artesanía.",
                    "gr" : "Πρακτικές και επαγγελματικές δεξιότητες Περιλαμβάνει επαγγελματικές δεξιότητες (προετοιμασία για ένα συγκεκριμένο επάγγελμα), τεχνικές, οικιακή οικονομία, λογιστική, επιχειρηματικές σπουδές, εκπαίδευση σταδιοδρομίας, ένδυση και κλωστοϋφαντουργία, οδήγηση, πολυτεχνικά μαθήματα, σπουδές γραμματείας, τουρισμός και φιλοξενία, χειροτεχνία",
                    "du" : "Praktische en beroepsvaardigheden. Omvat beroepsvaardigheden (voorbereiding op een specifiek beroep), techniek, huishoudkunde, accountancy, bedrijfskunde, loopbaanonderwijs, kleding en textiel, autorijden, huishoudkunde, hogeschoolopleidingen, secretariële studies, toerisme en gastvrijheid, handwerk "
                  }}
              ],
              "hasOther": true,
              "otherText": {
                "en" : "Other",
                "es" : "Otros",
                "gr" : "Άλλο",
                "du" : "Andere"
             },
              "selectAllText": "Reading, writing and literature: Includes reading and writing (andliterature) in the mother tongue, in the language of instruction, orin the tongue of the country (region) as a second language (fornon-natives); language studies, public speaking, literature"
             },
        
             {
              "type": "nouislider",
              "name": "youngstud",
              "title": {
                "en" : "How old are the youngest students you teach (in years)?",
                "es" : "¿Cuántos años tiene el estudiante más joven al que enseña?",
                "gr" : "Πόσο χρονών είναι οι νεότεροι μαθητές που διδάσκετε (σε έτη);",
                "du" : "Hoe oud zijn de jongste leerlingen/cursisten waaraan u lesgeeft (in jaren)?"
              },
              "rangeMin": 4,
              "rangeMax": 24,
            },
        
            {
              "type": "nouislider",
              "name": "oldstud",
              "title": {
                "en" : "How old are the oldest students you teach (in years)?",
                "es" : "¿Cuántos años tiene el estudiante más mayor al que enseña?",
                "gr" : "Πόσο χρονών είναι οι μεγαλύτεροι μαθητές που διδάσκετε (σε έτη);",
                "du" : "Hoe oud zijn de oudste leerlingen/cursisten waaraan u lesgeeft (in jaren)?"
              },
              "rangeMin": 4,
              "rangeMax": 24,
            },  
        
            ]
          },
        
          {
            "name" : "page 3",
            "description": "Demographics",
            "elements" : [
              
        
              {
                "type": "radiogroup",
                "name": "area",
                "title": {
                  "en" : "Which of the following best describes the area in which your school is located?",
                  "es" : "¿Cuál de las siguientes opciones describe mejor el área en la que se encuentra su centro?",
                  "gr" : "Ποιο από τα παρακάτω περιγράφει καλύτερα την περιοχή στην οποία βρίσκεται το σχολείο σας;",
                  "du" : "Welke van de volgende omschrijvingen beschrijft het beste het gebied waarin uw school is gevestigd?"
                },
                "choices": [
                 {
                  "value": "item1",
                  "text": {
                    "en" : "Rural",
                    "es" : "CRA (o tipología de centro rural agrupado)",
                    "gr" : "Αγροτική περιοχή",
                    "du" : "Landelijk"
                  }
                 },
                 {
                  "value": "item2",
                  "text": {
                    "en" : "Small town",
                    "es" : "Pueblo",
                    "gr" : "Μικρή πόλη",
                    "du" : "Kleine stad"
                  }
                 },
                 {
                  "value": "item3",
                  "text": {
                    "en" : "Suburban",
                    "es" : "Periferia",
                    "gr" : "Προάστιο ",
                    "du" : "Buitenwijk"
                  }
                 },
                 {
                  "value": "item4",
                  "text": {
                    "en" : "Urban",
                    "es" : "Ciudad",
                    "gr" : "Αστική περιοχή",
                    "du" : "Grootstad"
                  }
                 },
                 {
                  "value": "item5",
                  "text": {
                    "en" : "Other",
                    "es" : "Otros",
                    "gr" : "Άλλο",
                    "du" : "Andere"
                 }
                 }
                ]
               },
               {
                "type": "radiogroup",
                "name": "noofstuds",
                "title": {
                  "en" : "About how many students are in your school?",
                  "es" : "¿Cuántos estudiantes hay en tu centro?",
                  "gr" : "Πόσους περίπου μαθητές έχει το σχολείο σας;",
                  "du" : "Hoeveel leerlingen/cursisten zitten er ongeveer op uw school?"
                },
                "choices": [
                  {
                    "value": "item1",
                    "text": {
                      "en" : "Under 100",
                      "es" : "Menos de 100 ",
                      "gr" : "Κάτω από 100 ",
                      "du" : "Minder dan 100"
                    }
                  },
                    {
                    "value": "item2",
                    "text": {
                      "en" : "100-299",
                      "es" : "100-299",
                      "gr" : "100-299",
                      "du" : "100-299"
                    }},
                    {
                    "value": "item3",
                     "text": {
                     "en" : "300-599",
                     "es" : "300-599",
                     "gr" : "300-599",
                     "du" : "300-599"
                   }},
                   {
                    "value": "item4",
                    "text": {
                      "en" : "600-999",
                      "es" : "600-999",
                      "gr" : "600-999",
                      "du" : "600-999"
                    }},
                    {
                    "value": "item5",
                    "text": {
                      "en" : "Over 1000",
                      "es" : "Más de 1000 ",
                      "gr" : "Πάνω από 1000",
                      "du" : "Meer dan 1000"
                   }}
                ]
               }
        
               ,
        
        
               {
                "type": "nouislider",
                "name": "percofstuds",
                "title": {
                  "en" : "Please estimate the percentage of students in your school who are from socioeconomically disadvantaged homes.",
                  "es" : "Estima el porcentaje de estudiantes en tu centro que provienen de hogares socioeconómicamente desfavorecidos.",
                  "gr" : "Παρακαλώ υπολογίστε το ποσοστό των μαθητών στο σχολείο σας που προέρχεται από κοινωνικοοικονομικά μειονεκτούντα σπίτια/νοικοκυριά.",
                  "du" : "Maak een schatting van het percentage leerlingen/cursisten op uw school dat afkomstig is uit sociaal-economisch achtergestelde gezinnen."
                },
                "rangeMin": 0,
                "rangeMax": 100,
              },
        
        
              {
                "type": "radiogroup",
                "name": "gendermix",
                "title": {
                  "en" : "What is the student gender mix in your school?",
                  "es" : "En su centro ¿qué género de estudiantes hay?",
                  "gr" : "Ποιο είναι το μείγμα φύλου των μαθητών στο σχολείο σας;",
                  "du" : "Wat is de gendermix van studenten op uw school?"
                },
                "choices": [
                  {
                    "value": "item1",
                    "text": {
                      "en" : "Mixed",
                      "es" : "Mixto ",
                      "gr" : "Μικτό",
                      "du" : "Gemengd"
                    }},
                    {
                    "value": "item2",
                    "text": {
                      "en" : "Girls only",
                      "es" : "Solo chicas ",
                      "gr" : "Μόνο κορίτσια ",
                      "du" : "Alleen meisjes"
                    }},
                    {
                    "value": "item3",
                    "text": {
                      "en" : "Boys only",
                      "es" : "Solo chicos ",
                      "gr" : "Μόνο αγόρια",
                      "du" : "Alleen jongens"
                   }}
                ]
               },

                // @New question
               {
                "type" : "text",
                "name" : "gender",
                "title": {
                  "en" : "Describe your school or institution (e.g., post-primary school, general education, second-chance education, special education setting, vocational, etc).",
                  "es" : "Describa su escuela o institución (instituto, educación primaria-infantil, educación de segunda oportunidad, educación especial, formación profesional, etc.).",
                  "gr" : "Περιγράψτε το σχολείο ή το ίδρυμά σας (γενική εκπαίδευση, εκπαίδευση δεύτερης ευκαιρίας, ειδική εκπαίδευση, επαγγελματική, κ.λπ.).",
                  "du" : "Beschrijf uw school of instelling (algemeen secundair onderwijs, technisch secundair onderwijs, beroepssecundair onderwijs, tweedekansonderwijs, buitengewoon onderwijs, enz.)."
                },
                "width" : "40em",


               }
               ,


               {
                "type": "radiogroup",
                "name": "paid",
                "title": {
                  "en" : "Is your school fee-paying?",
                  "es" : "¿Tu centro es público?",
                  "gr" : "Είδος σχολείου",
                  "du" : "Is er inschrijvingsgeld?"
                },
                "choices": [
                  {
                    "value": "item1",
                    "text": {
                      "en" : "Yes",
                      "es" : "Sí  ",
                      "gr" : "Δημόσιο",
                      "du" : "Ja "
                    }
                   },
                   {
                    "value": "item2",
                    "text": {
                      "en" : "No",
                      "es" : "No ",
                      "gr" : "Ιδιωτικό",
                      "du" : "Nee"
                    }
                   },
                   {
                    "value": "item3",
                    "text": {
                      "en" : "There is a voluntary contribution",
                      "es" : "Hay una contribución voluntaria (concertado)",
                      "gr" : "Υπάρχει εθελοντική συνεισφορά ",
                      "du" : "Er is een vrijwillige bijdrage"
                    }
                   },
                   {
                    "value": "item4",
                    "text": {
                      "en" : "I don't know",
                      "es" : "No lo sé ",
                      "gr" : "Δεν γνωρίζω ",
                      "du" : "Ik weet het niet"
                    }
                   }
                ]
              },
        
        
        
              //
        
        
        
            
        
          
        
         
        
        
        
        
            ]
          },

    // 
  
      
      
      
     

  //   ----------------------------------------------End of Carousel Question




//   ----------------------------------------------End of Carousel Question


//   ----------------------------------------------Start of Carousel Question Page 6


//   ----------------------------------------------End of Carousel Question


//   ----------------------------------------------Start of Carousel Question Page 7


//   ----------------------------------------------End of Carousel Question

//   ----------------------------------------------Start of Carousel Question Page 8

//   ----------------------------------------------End of Carousel Question

//   ----------------------------------------------Start of Carousel Question Page 9

//   ----------------------------------------------End of Carousel 

//   ----------------------------------------------Start of Carousel Question Page 10


//   ----------------------------------------------End of Carousel Question


//   ----------------------------------------------Start of Carousel Question Page 11

//   ----------------------------------------------End of Carousel Question

//   ----------------------------------------------Start of Carousel Question Page 12


//   ----------------------------------------------End of Carousel Question

//   ----------------------------------------------Start of Carousel Question Page 13


//   ----------------------------------------------End of Carousel Question

//   ----------------------------------------------Start of Carousel Question Page 14

//   ----------------------------------------------End of Carousel Question


//   ----------------------------------------------Start of Carousel Question Page 15

//   ----------------------------------------------End of Carousel Question

//   ----------------------------------------------Start of Carousel Question Page 16


//   ----------------------------------------------End of Carousel Question


//   ----------------------------------------------Start of Carousel Question Page 17

//   ----------------------------------------------End of Carousel Question


//   ----------------------------------------------Start of Carousel Question Page 18

//   ----------------------------------------------End of Carousel Question

//  

     

  
      
  
    ],


    showQuestionNumbers: "off",
    // "title": "UDL BOE REAL",
    
    // "description" : "Welcome to the Universal Design for Learning survey. Universal Design for Learning (UDL) is an approach to teaching and learning that aims to give all students equal opportunity to succeed. Are you a school teacher? Are you interested in inclusive education? We would love to hear from you. What is involved?  We would like to ask you some questions about how you plan and run the classes you teach using a Universal Design for Learning framework. The questionnaire is fully anonymised and we will not ask you for your name or any other identifying information.  This will take about 10 minutes. This project is part of the UDL-BOE Erasmus+ project which is funded by the European Union to support post-primary teachers in building inclusive digital learning experiences. If you want any information about the project and how the results will be used, please contact: info@udl-boe.eu or Ann Devitt, devittan@tcd.ie.",
    "showProgressBar": "top",
    "showCompletedPage" : "false",

    "pageNextText" : {
      "en" : "Next",
      "es" : "Siguiente",
      "gr" : "Επόμενο",
      "du" : "Volgende"
    },
    
    "pagePrevText" : {
      "en" : "Previous",
      "es" : "Anterior",
      "gr" : "Προηγούμενο",
      "du" : "Vorige"
    },
    "completeText"  : {
      "en" : "Complete",
      "es" : "Completado",
      "gr" : "Ολοκληρωμένο",
      "du" : "Voltooid"
    }
    
  };